import React from 'react';
import { ExternalUrlAdminTranslation } from 'app/area/external-urls-administration/constants';
import styles from './list-heading.scss';

interface ListHeadingProps {
  disabledItemExists: boolean;
  translation: ExternalUrlAdminTranslation;
}

export const ListHeading: React.FC<ListHeadingProps> = ({ disabledItemExists, translation }) => {
  return <div className={styles.headingContainer}>
    <div className={styles.defaultColumn}>{translation.column_description}</div>
    <div className={styles.defaultColumn}>{translation.column_url_template}</div>
    {disabledItemExists && <div className={styles.fixedColumn} />}
  </div>;
};
